import getJSON from "@/js/libs/getJSON";
import summary from "@/js/parts/checkout/refreshSummary";
import isInCart from "@/js/libs/isInCart";

let APP = window.APP || {};
const action = "commerce/cart/update-cart";

// One big init function, assume polyfils and docready when this is called:
export default function (element, group, validate) {
  let options = {};
  let optionAttribute = element.getAttribute("data-options");
  if (optionAttribute) {
    optionAttribute.split("|").forEach((part) => {
      let keyValue = part.split(":");
      options[keyValue[0]] = keyValue[1];
    });
  } else {
    options = false;
  }

  if (!options) {
    console.warn("no camper ID set, will not add or remove via ajax");
    return;
  }

  // set the current lineItem
  element.dataset.purchasableId = "";
  for (let i = 0; i < element.options.length; i++) {
    let purchasableId = element.options[i].value;
    let lineItem = isInCart(
      { lineItems: APP.lineItems },
      purchasableId,
      options,
    );
    if (lineItem) {
      ++group.dataset.total;
      element.value = purchasableId;
      element.dataset.purchasableId = purchasableId;
    }
  }

  validate(group);

  const states = {
    loading: function () {
      summary.loading();
      group.style.opacity = 0.5;
    },
    refresh: function () {
      summary.refresh(function () {
        group.style.opacity = 1;
      });
    },
    ready: function () {
      summary.ready();
      group.style.opacity = 1;
    },
  };

  const add = function (formData, purchasableId) {
    formData.set("purchasableId", purchasableId);
    formData.set("qty", 1);

    if (options) {
      for (let handle in options) {
        formData.set("options[" + handle + "]", options[handle]);
      }
    }
  };

  const remove = function (formData, lineItemId) {
    formData.set("lineItemId", lineItemId);
    formData.set("lineItems[" + lineItemId + "][remove]", 1);
  };

  const success = function (json) {
    APP.lineItems = json.cart.lineItems;
    element.dataset.purchasableId = element.options[element.selectedIndex].value;
    states.refresh(json);
    validate(group);
  };

  const error = function (err) {
    console.log(err);
    let data = err.response.data;
    APP.showModal(data.message);
    element.value = element.dataset.purchasableId;
    states.ready();
  };

  const post = function (formData) {
    states.loading();
    formData.set("action", action);
    formData.set(APP.config.csrfName, APP.config.csrfValue);
    getJSON(window.location.href, formData, success, error);
  };

  // kick it all off:
  element.addEventListener("change", () => {
    let newPurchasableId = element.options[element.selectedIndex].value;
    let previousPurchasableId = element.dataset.purchasableId;
    let formData = new FormData();

    if (previousPurchasableId && !newPurchasableId) {

      // TODO: doesn't work if 'Select sesion' is chosen

      let lineItem = isInCart(
        { lineItems: APP.lineItems },
        previousPurchasableId,
        options,
      );
      if (lineItem) {
        remove(formData, lineItem.id);
      } else {
        console.warn("Tried to remove item not in cart");
        element.value = element.options[element.selectedIndex].value;
      }
    }

    if (newPurchasableId && !previousPurchasableId) {
      let lineItem = isInCart(
        { lineItems: APP.lineItems },
        newPurchasableId,
        options,
      );
      if (lineItem) {
        console.warn("Tried to add item already in cart");
        element.value = element.options[element.selectedIndex].value;
      } else {
        add(formData, newPurchasableId);
      }
    }

    if (newPurchasableId && previousPurchasableId) {
      let previousLineItem = isInCart(
        { lineItems: APP.lineItems },
        previousPurchasableId,
        options,
      );
      let newLineItem = isInCart(
        { lineItems: APP.lineItems },
        newPurchasableId,
        options,
      );

      if (newLineItem) {
        console.warn("Tried to add item already in cart");
        element.value = element.dataset.purchasableId;
      } else {
        add(formData, newPurchasableId);
        if (previousLineItem) {
          remove(formData, previousLineItem.id);
        } else {
          console.warn("Tried to remove item not in cart");
        }
      }
    }

    if (formData.get("purchasableId") || formData.get("lineItemId")) {
      post(formData);
    }
  });
}
